import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import {
  Grid,
  MenuItem,
  TextField,
  Button,
  Tooltip,
  ThemeProvider,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DownloadHistory } from "../HistoryData/JavaScript";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
//import GppGoodIcon from "@material-ui/icons/GppGood";
//import RadioButtonUncheckedOutlinedIcon from '@mui/icons/RadioButtonUncheckedOutlined';
import RadioButtonUncheckedOutlinedIcon from "@material-ui/icons/RadioButtonUncheckedOutlined";
//import RadioButtonCheckedOutlinedIcon from '@material-ui/icons/RadioButtonCheckedOutlined';
import Box from "@material-ui/core/Box";
import * as FileSaver from "file-saver";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogContent from "@material-ui/core/DialogContent";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
//import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
//import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
//import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DatePicker } from "@material-ui/pickers";

import {
  AddBox,
  Check,
  DeleteOutline,
  Edit,
  SaveAlt,
  FilterList,
  FirstPage,
  LastPage,
  ChevronRight,
  ChevronLeft,
  Clear,
  Search,
  ArrowDownward,
  Remove,
  ViewColumn,
} from "@material-ui/icons";
import * as XLSX from "xlsx";
import axios from "axios";
import DateFnsUtils from "@date-io/date-fns";
import { forwardRef } from "react";
//import { useEffect } from "react";
const api = axios.create({
  baseURL: "InventoryMasterDetails",
});
//getHistoricalData
const apiHistoricalData = axios.create({
  baseURL: "InventoryAudit",
});
const api_SapUpload = axios.create({
  baseURL: "PhyInvSAPUpload",
});
const api_historyFilter = axios.create({
  baseURL: "InventoryAudit",
});

export const tableIconsInputScreen = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => (
    <Check {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
  )),
  Clear: forwardRef((props, ref) => (
    <Clear {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
  )),
  Delete: forwardRef((props, ref) => (
    <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
  )),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => (
    <Edit {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
  )),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => (
    <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
  )),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
const tableHeaderStyle = {
  backgroundColor: "var(--light-sand)",
  color: "var(--dark-blue)",
};
export const tableOptionsUser = {
  headerStyle: tableHeaderStyle,
  showTitle: false,
  draggable: false,
  pageSize: 3,
  // search: true,
  // add: true,
  pageSizeOptions: [5, 10, 25, 50],
  paginationPosition: "bottom",
  //paging: false,
  maxBodyHeight: "600px",
};

export const HistoricalData = (props) => {
  const [plant, setPlant] = useState([]);
  const [plantData, setPlantData] = useState("");
  const [openLoader, setopenLoader] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [mData, setmData] = useState();

  const [toPeriod, setToPeriod] = useState(null);
  const [fromPeriod, setFromPeriod] = useState(null);
  const [isfromPeriod, setIsfromPeriod] = useState(false);
  const [istoPeriod, setIstoPeriod] = useState(false);
  //let workFlowData = [];
  //for error handling
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [severity, setSeverity] = useState("success");

  //modal
  const [openModalDownload, setOpenModalDownload] = useState(false);
  const [closeModalDownload, setCloseModalDownload] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  var isSelected1 = false;
  const [toDate, setToDate] = useState("");

  const token = useSelector((state) => state.saveAzureTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken
  );
  const uId = useSelector((state) => state.saveUIDReducer.uid);

  let errorList = [];

  function getPlant(ID) {
   // console.log("id", ID);
    const headers = {
        Authorization: "Bearer " + bearerToken,
        UserEmail: userDetails.emailId,
        userId: uId,
        RoleName: userDetails.roleName,
        Gid: userDetails.gid,
        Roleid: userDetails.roleId,
       // AzureToken: token,
      };
    setopenLoader(true);
    api
      .get("/getTblMstPlant/" + ID,{
        headers: headers,
      })
      .then((res) => {
       // console.log("plantdata", res.data);
        setPlant(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }

  //const [workFlowLoc, setworkFlowLoc] = useState();
  //const [downloadLoc, setDownloadLoc] = useState();
  // function downloadLocation(dataFromWflow) {
  //    //console.log("dataFromWflow", dataFromWflow)
  //    // var dataFromWflow = [];
  //     dataFromWflow.map((x) => { if (x.tableData.checked) { console.log("sinya")} })

  //    let response = [];
  //    let errorList = [];

  //    //reset();
  //}
  //DownloadWorkFlow
  //api_historyFilter
  const [historyData, setHistoryData] = useState([]);
  function getHistory() {
    setopenLoader(true);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
     // AzureToken: token,
    };
    apiHistoricalData
      .get("/getHistoricalData",{
        headers: headers,
      })
      .then((res) => {
       // console.log("historicalData", res.data);
        setHistoryData(res.data);
        // downloadLocation(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }
  //for
  const [workFlowData, setWorkFlowData] = useState();
  function getWorkFlowDetails() {
    setopenLoader(true);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
     // AzureToken: token,
    };
    api_SapUpload
      .get("/getWorkFlowDetails/",{
        headers: headers,
      })
      .then((res) => {
       // console.log("sapdo", res.data);
        setWorkFlowData(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api : getWorkFlowDetails!!");
        setopenLoader(false);
      });
  }

  async function handleRefresh() {
    let response = [];
    let errorList = [];
    let data = {
      PlantName: plantData,
      WorkflowStartDate: fromPeriod,
      WorkflowEndDate: toPeriod,
    };

    let isValidate = true;
    if (isValidate) {
      setopenLoader(true);
      await api_historyFilter
        .post("/gethistoricaldtabasedonfilters/", data)
        .then((result) => {
         // console.log("result", result);
          response = result.data;
          setHistoryData(response); //newly added
          setopenLoader(false);
          //if (response.result.slipTempResult != null) {
          //    if (response.result.slipTempResult.length > 0) {
          //        setviewSlipData(response.result.slipTempResult);
          //        console.log("VIEW RESPONSE!!", response.result.slipTempResult);
          //    }
          //}
          errorList.push("data fetch successfully!!!");
          showMessage(errorList, true, "success");
        })
        .catch((error) => {
          console.log("Error : ", error);
          setopenLoader(false);
          errorList.push("Something went wrong!");
          showMessage(errorList, true, "error");
        });
    } else {
      setopenLoader(false);
    }
    //reset();
  }

  //newpost
  async function handleRefreshPostForPlant() {
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    let response = [];
    let errorList = [];
    let data = {
      PlantName: plantData,
      //WorkflowStartDate: fromPeriod,
      //WorkflowEndDate: toPeriod,
    };

    let isValidate = true;
    if (isValidate) {
      setopenLoader(true);
      await api_historyFilter
        .post("/gethistoricaldataplantnamefilters/", data,{headers: headers})
        .then((result) => {
         // console.log("result", result);
          response = result.data;
          setHistoryData(response); //newly added
          setopenLoader(false);
          //if (response.result.slipTempResult != null) {
          //    if (response.result.slipTempResult.length > 0) {
          //        setviewSlipData(response.result.slipTempResult);
          //        console.log("VIEW RESPONSE!!", response.result.slipTempResult);
          //    }
          //}
          errorList.push("data fetch successfully!!!");
          showMessage(errorList, true, "success");
        })
        .catch((error) => {
          console.log("Error : ", error);
          setopenLoader(false);
          errorList.push("Something went wrong!");
          showMessage(errorList, true, "error");
        });
    } else {
      setopenLoader(false);
    }
    //reset();
  }

  //new
  function getRefreshApi(PlantName) {
    const options = {
      method: "get",
      //responseType: "arraybuffer",
      headers: { 
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId, },
      //params: { poentryid: poentryid },
      //params: { PlantName: PlantName, Workflow: Workflow },
    };
    return axios
      .post(
        "/InventoryAudit/gethistoricaldataplantnamefilters?PlantName=" +
          { PlantName },
        options
      )
      .then((response) => {
       // console.log("response");
        //setFlocRep(response);
        //return response;
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  }

  async function refreshPlantData() {
    setopenLoader(true);
    let response = [];
    let errorList = [];

    //let data = {
    //    Workflow: workFlowD[0],
    //    PlantName: plantD[0],

    //}

    let isValidate = true;

    getRefreshApi(plantData)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.byteLength <= 200) {
            setopenLoader(false);
            errorList.push("congo");
            showMessage(errorList, true, "error");
          }
        } else {
          console.log("*");
        }
      })

      .catch((error) => {
        console.log("error");
      });
  }

  const [valueChecked, setValueChecked] = useState(false);

  function GetEditButton(rowData) {
    return (
      <Tooltip title="Select Workflow" placement="bottom">
        <span>
          <Button href="javascript:void(0)">
            <span>
              <Button>view</Button>
            </span>
          </Button>
        </span>
      </Tooltip>
    );
  }

  function showMessage(errorList, flag, severity) {
    setErrorMessages(errorList);
    setIserror(flag);
    setSeverity(severity);
  }

  const handlePlant = (e) => {
    //console.log("handlePlant", e.target.value);
    setPlantData(e.target.value);
  };

  const handleOpener = (rows) => {
    //isSelected = true;
    //setSelectedRows
    setIsSelected(true);

    //if (!isSelected) {
    //    setOpenModalDownload(true);
    //}

    if (isSelected) {
      setOpenModalDownload(false);
    }
  };
  const [selectedD, setSelectedD] = useState();

  const handleOpenerReal = (rows) => {
   // console.log("rows", rows);
    setopenLoader(true);
    setSelectedD(rows);
    isSelected1 = true;
    setValueChecked(true);
    setmData(rows.tableData.id);
    // rows.map(x => console.log("selected", setmData(x.tableData.id)));
    //rows.map(x => console.log("selected", setmData(x.tableData.checked)));

    //if (isSelected1 && rows.length == 1) {

    //    setopenLoader(false);
    //    setOpenModalDownload(true);
    //}
    if (rows) {
      setopenLoader(false);
      setOpenModalDownload(true);
    }
  };
 // console.log("selectedD", selectedD);
  //if (selectedD && selectedD.length == 1) {
  //    selectedD.map(x => setmData(x.tableData.checked));
  //}
 // console.log("mData", mData);
  const Refresh = () => {
    console.log("****");
  };
  const handleClear = () => {
   // console.log("sinya");
    setPlantData("");
    setFromPeriod(null);

    setToPeriod(null);
  };
  useEffect(() => {
    getPlant(props.loginuser.response.gid);
    getHistory();
    getWorkFlowDetails();
  }, []);

  //{ title: " Select", field: "" },
  var columns1 = [
    { title: "Workflow", field: "workflow" },
    { title: "Start Date", field: "workflowStartDate" },
    { title: "End Date", field: "workflowEndDate" },
    { title: "Plant Name", field: "plantName" },
    { title: "File Name", field: "fileName" },
    { title: "Created By", field: "createdBy" },
    { title: "Status", field: "status" },
  ];
  var columns = [
    { title: " Slip Number", field: "auditSlipNumber" },
    { title: "Plant Name", field: "plantName" },
    { title: "Location", field: "locationName" },
    { title: "Material Name", field: "material" },
    { title: "Material Description", field: "materialDescription" },
    { title: " ABC Classification", field: "abcclassiification" },
    { title: "Unit Of Measure", field: "unitOfMeasurement" },
    { title: "Counted Physical Quantity", field: "countedPhyQuantity" },
    { title: "Remarks", field: "auditedQuantity" },
    { title: "Slip Created By", field: "mismatchQuantity" },
    { title: "Slip Modified By", field: "remarks" },
    { title: "Slip Creation Timestamp", field: "auditeddBy" },
    { title: "Slip Modification Timestamp", field: "createdDate" },
  ];
  return (
    <ThemeProvider theme={lightTheme}>
      <div className="master-layout-data">
        <Box paddingTop={{ xs: "5rem", sm: "2rem" }} className="">
          <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">
            Historical Data
          </h3>
        </Box>

        <Grid container spacing={2} className="data-part">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              className="lightInputFields"
              select
              id=""
              //disabled={true}
              label="Plant Name"
              variant="filled"
              fullWidth
              name=""
              value={plantData}
              onChange={handlePlant}
            >
              {plant.map((h, i) => (
                <MenuItem key={i} value={h.plantName}>
                  {h.plantName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                id="fromPeriod"
                className="datepicker"
                label="Start date"
                format="dd/MM/yyyy"
                fullWidth
                value={fromPeriod}
                disabled={isfromPeriod}
                InputProps={{ readOnly: true }}
                onChange={(newValue) => {
                  {
                    setFromPeriod(
                      new Date(newValue).toISOString().split("T")[0]
                    );
                  }
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                id="toPeriod"
                className="datepicker"
                label="End date"
                format="dd/MM/yyyy"
                fullWidth
                InputProps={{ readOnly: true }}
                value={toPeriod}
                disabled={istoPeriod}
                onChange={(newValue) => {
                  {
                    setToPeriod(new Date(newValue).toISOString().split("T")[0]);
                    //ValidatePeriod(new Date(newValue).toISOString().split("T")[0]);
                  }
                  //
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>

        <Grid className="main">
          <Grid className="refresh-history">
            <Grid item xs={12} sm={2}>
              <Button
                className="ns-btn-primary mt-1 mr-1 new-margin "
                onClick={
                  plantData != null && fromPeriod != null && toPeriod != null
                    ? handleRefresh
                    : plantData == null &&
                      fromPeriod == null &&
                      toPeriod == null
                    ? getHistory
                    : handleRefreshPostForPlant
                }
              >
                <span>Refresh</span>
              </Button>
            </Grid>
          </Grid>

          <Grid className="refresh-history">
            <Grid item xs={12} sm={2}>
              <Button
                className="ns-btn-primary mt-1 mr-1 new-margin"
                onClick={handleClear}
              >
                <span>clear</span>
              </Button>
            </Grid>
          </Grid>
        </Grid>

        {/*newly added table*/}

        <Grid item xs={12}>
          <Grid item xs={12}>
            <MaterialTable
              title=""
              columns={columns1}
              data={historyData}
              icons={tableIconsInputScreen}
              //isLoading={isLoader}
              options={{ tableOptionsUser, exportButton: { csv: true } }}
              //selection: true
              actions={[
                (rowData) => ({
                  icon: GetEditButton,

                  tisFreeAction: true,

                  onClick: (event, rowData) => {
                    return setSelectedRows(rowData), handleOpenerReal(rowData);
                  },
                }),
              ]}

              //onSelectionChange={(rows) => {return setSelectedRows(rows), handleOpenerReal(rows) } }
            />
          </Grid>
        </Grid>

        {/**  <button onClick={() => { setOpenModalDownload(true)}}>open modal</button >*/}

        {openModalDownload ? (
          <DownloadHistory
            selectedD={selectedD}
            setmData={setmData}
            mData={mData}
            historyData1={historyData}
            selectedRows1={selectedRows}
            openModalDownloadD={openModalDownload}
            closeModalDownloadD={closeModalDownload}
            setOpenModalDownloadD={setOpenModalDownload}
            setCloseModalDownloadD={setCloseModalDownload}
          />
        ) : (
          ""
        )}
        <Dialog
          open={openLoader}
          //onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
          id="templateUploadSuccess"
          PaperProps={{
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
              borderColor: "transparent",
            },
          }}
        >
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>
      </div>
    </ThemeProvider>
  );
};
